<script setup lang="ts">
import { inject } from 'vue'
import { useToast as usePrimeToast } from 'primevue/usetoast'
import { removePage } from '~/layers/cms/app/composables/cms'

const toast = usePrimeToast()
const dialogRef = inject<DialogRef>('dialogRef')

interface DialogRef {
  value: {
    data: {
      slug: string
    }
    close(): void
  }
}

const closeDialog = () => {
  if (!dialogRef) return
  dialogRef.value.close()
}

const deletePage = async () => {
  if (!dialogRef || !dialogRef.value.data.slug) return

  const response = await removePage(dialogRef.value.data.slug)
  if (!response.status_ok) {
    toast.add({
      severity: 'error',
      summary: 'Error',
      detail: 'Nie udało się usunąć strony',
      life: 3000
    })
  } else {
    toast.add({
      severity: 'info',
      summary: 'Info',
      detail: 'Poprawnie usunięto stronę',
      life: 3000
    })
    closeDialog()
  }
}
</script>

<template>
  <div class="flex flex-col gap-4">
    <Button
      type="button"
      label="Potwierdź"
      severity="primary"
      @click="deletePage"
    />
  </div>
</template>
